import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "output", "placeholder"];
  static values = {
    production: Boolean,
  };

  initialize() {
    window.submitInvisibleRecaptchaForm =
      this.submitInvisibleRecaptchaForm.bind(this);
  }

  submitInvisibleRecaptchaForm() {
    this.element.submit();
  }

  // Always one submission: without preventDefault the click also submits the form, and in
  // the app (Turbo on) that sent a second POST that failed with "email already taken".
  execute(ev) {
    ev.preventDefault();
    if (this.productionValue) {
      grecaptcha.execute();
    } else {
      this.element.submit();
    }
  }
}
